import axios from '@/api/axios'

const createTariff = tariffInput => {
  return axios.post('/tariff/list', tariffInput)
}

const getTariff = params => {
  return axios.get(`/tariff${params}`)
}

const getTariffList = params => {
  return axios.get(`/tariff/list${params}`)
}

const deleteTariff = id => {
  return axios.delete(`/tariff/list/${id}`)
}

export default {
  createTariff,
  getTariff,
  getTariffList,
  deleteTariff
}
